import { publicClient, privateClient } from './client';
import { PromotionDetails } from './PromotionDetails';

const customPromotionDetails = (pub: boolean) => new PromotionDetails(pub ? publicClient : privateClient);
export default customPromotionDetails;
